import { print } from "graphql";

import { graphql } from "lib/generated/app-service-gql";
import { DocumentSummaryUpdatesSubscription } from "lib/generated/app-service-gql/graphql";
import { useDocumentAiRunUpdates } from "./useDocumentAiRunUpdates";
import { documentSummaryCachedQueryKey } from "./useDocumentSummaryCached";

const documentSummaryUpdatesSubscriptionDoc = graphql(`
  subscription documentSummaryUpdates($operationId: String!) {
    documentSummaryUpdates(operationId: $operationId) {
      operationId
      status
    }
  }
`);

// codegen scans the template literal above for types; `useSubscription` needs the string form.
const documentSummaryUpdatesSubscriptionString = print(documentSummaryUpdatesSubscriptionDoc);

type Props = {
  documentId: string;
  operationId: string | null;
  enabled: boolean;
};

export function useDocumentSummaryUpdates({ documentId, operationId, enabled }: Props) {
  return useDocumentAiRunUpdates<DocumentSummaryUpdatesSubscription>({
    subscription: documentSummaryUpdatesSubscriptionString,
    operationId,
    enabled,
    queryKey: documentSummaryCachedQueryKey(documentId),
    getStatus: (data) => data.documentSummaryUpdates.status,
  });
}
